import React from 'react'
import MDEditor, {commands} from '@uiw/react-md-editor'
import {DEFAULT_TITLE_EXECUTE_STRING} from '../../../../pages/post/announcement/AnnounceCreate'

interface IProps {
    value: string
    setValue: React.Dispatch<React.SetStateAction<string>>
    handleMarkdownImage?: (event: React.DragEvent<HTMLDivElement>) => void
}

const AnnouncementInputView: React.FC<IProps> = ({value, setValue, handleMarkdownImage}) => {
    return (
        <MDEditor
            autoFocus
            highlightEnable={false}
            maxHeight={3000}
            minHeight={3000}
            preview={'edit'}
            height="100%"
            value={value}
            textareaProps={{
                placeholder: 'Please enter Markdown text',
            }}
            onChange={setValue}
            onDrop={handleMarkdownImage}
            commands={commandsCollections}
        />
    )
}

const setTitle = {
    name: 'setTitle',
    keyCommand: 'setTitle',
    render: (command, disabled, executeCommand) => {
        return (
            <button
                aria-label="Insert title"
                disabled={disabled}
                onClick={evn => {
                    evn.stopPropagation()
                    executeCommand(command, command.groupName)
                }}>
                Title
            </button>
        )
    },
    execute: (state, api) => {
        let modifyText: string
        if (!state.selectedText) {
            modifyText = DEFAULT_TITLE_EXECUTE_STRING
        }
        api.replaceSelection(modifyText)
    },
}

const setLinkButton = {
    name: 'setLinkButton',
    keyCommand: 'setLinkButton',
    render: (command, disabled, executeCommand) => {
        return (
            <button
                aria-label="Insert Link Button"
                disabled={disabled}
                onClick={evn => {
                    evn.stopPropagation()
                    executeCommand(command, command.groupName)
                }}>
                Link Button
            </button>
        )
    },
    execute: (state, api) => {
        let modifyText: string
        if (!state.selectedText) {
            modifyText =
                '\n' +
                '[Link]: https://leagueoftraders.io' +
                '\n' +
                '[![{align: center}](https://img.shields.io/badge/Title-37a779?style=for-the-badge)][Link]' +
                '\n'
        }
        api.replaceSelection(modifyText)
    },
}

const setTitleGroup = commands.group(
    [commands.title1, commands.title2, commands.title3, commands.title4, commands.title5, commands.title6],
    {
        name: 'title',
        groupName: 'title',
        buttonProps: {'aria-label': 'Insert title'},
    },
)

const commandsCollections = [
    setTitleGroup,
    commands.link,
    commands.code,
    commands.codeBlock,
    commands.hr,
    commands.bold,
    commands.italic,
    commands.divider,
    commands.unorderedListCommand,
    commands.orderedListCommand,
    commands.checkedListCommand,
    commands.divider,
    setTitle,
    commands.divider,
    setLinkButton,
]

export default AnnouncementInputView
